var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 32L58 28",
    stroke: "#F7B500",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 42C28.2 42 30.199 42.9017 31.6486 44.3514C33.0983 45.801 34 47.8 34 50C34 52.2 33.0983 54.199 31.6486 55.6487C30.199 57.0983 28.2 58 26 58C23.8 58 21.801 57.0983 20.3514 55.6487C18.9017 54.199 18 52.2 18 50C18 47.8 18.9017 45.801 20.3514 44.3514C21.801 42.9017 23.8 42 26 42Z",
    stroke: "#8372FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 50.5V20.6149C58 18.1797 55.8424 16.3096 53.4319 16.6554L37.4319 18.9511C35.4624 19.2337 34 20.9209 34 22.9106V50.5",
    stroke: "#8372FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 42C52.2 42 54.199 42.9017 55.6486 44.3514C57.0982 45.801 58 47.8 58 50C58 52.2 57.0982 54.199 55.6486 55.6487C54.199 57.0983 52.2 58 50 58C47.7999 58 45.801 57.0983 44.3513 55.6487C42.9017 54.199 42 52.2 42 50C42 47.8 42.9017 45.801 44.3513 44.3514C45.801 42.9017 47.7999 42 50 42Z",
    stroke: "#FA6400",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMusic);
export default __webpack_public_path__ + "static/media/add-music.62aff17f.svg";
export { ForwardRef as ReactComponent };